import { DSImageProps, DSNCApp, DSRawVideo, DSVideo } from 'shared-definitions/types'
import { ApiComponentProductApp } from 'data-source/types.wp'
import { youtubeVideoId } from 'shared-code/string'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { PLinkMapperOpts } from 'data-source/mappers/pLinkMapper'
import { nullableString } from 'shared-code/conversion'

export function ncApp(input: ApiComponentProductApp, opts: PLinkMapperOpts): DSNCApp[] {
  return input.apps.map(item => ({
    resource: 'nc-app',
    name: item.name,
    description: item.description ?? null,
    images: item.images.map(i => imageMapper(i, opts)).filter(i => i !== null) as DSImageProps[],
    video: parseVideo(item.video_url),
    pLinkEdit: item.edit_url ? { href: item.edit_url, target: '_blank' } : null,
    apps: item.store_links.map(app => ({
      currency: app.currency ?? null,
      icon: app.icon,
      price: app.price ?? null,
      isFree: app.free,
      havePurchases: app.app_purchase,
      link: {
        label: app.store_name,
        pLink: { href: app.store_url, target: '_blank' },
      },
    })),
  }))
}

function parseVideo(input?: string | null): DSVideo | DSRawVideo | null {
  const videoUrl = nullableString(input)
  if (!videoUrl) {
    return null
  }

  const youtubeId = youtubeVideoId(videoUrl)
  if (youtubeId) {
    return { youtubeId }
  }

  return { videoUrl }
}
